"use client"

import { storeRef } from "@/components/providers/StoreProvider"
import { thunks } from "@/lib/redux/thunks"

let refCalled: any = {}

export const getFareRules = ({ lang = "vi" }: { lang?: string }, _dispatch?: any) => {
  const flightState = storeRef.current?.getState().flight
  const selectedInputFlight = flightState?.inputFlights[flightState?.selectedFligthInputIndex]
  const isDomestic = ![
    selectedInputFlight?.fromAirport,
    selectedInputFlight?.toAirport
  ].some(airport => {
    return `${airport?.isDomestic}` === '0'
  })
  let key = `${isDomestic ? 1 : 0}_${lang}`

  if (!!refCalled[key]) return;
  refCalled = {
    [key]: true
  }

  const dispatch = _dispatch || storeRef.current?.dispatch

  if (isDomestic) {
    dispatch(thunks.get_fare_rules_1({
      body: {
        flightType: "1",
        lang
      }
    }) as any)
  } else {
    dispatch(thunks.get_fare_rules_0({
      body: {
        flightType: "0",
        lang
      }
    }) as any)
  }
}